export const OAUTH_APPS_PAGE_ID = 't6u7v8w9-x0y1-2345-6789-012345678901';
export const OAUTH_APPS_PATH = '/portal/oauth-apps';
export const OAUTH_CONNECTION = 'backend_py';
export const OAUTH_API_BASE = '/api/v1/oauth';

export const ALLOWED_SCOPES = ['openid', 'profile', 'email', 'connectors:read'] as const;
export type AllowedScope = (typeof ALLOWED_SCOPES)[number];

export const CLIENT_TYPES = ['confidential', 'public'] as const;
export type ClientType = (typeof CLIENT_TYPES)[number];
